import script from "./ButtonSliderNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonSliderNavigation.vue?vue&type=script&setup=true&lang=js"

import "./ButtonSliderNavigation.vue?vue&type=style&index=0&id=433a9e78&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-433a9e78"]])

export default __exports__